import { HTTP } from '../../../http-common';
import { getField, updateField } from 'vuex-map-fields';
import { Address } from '../../../models/SQAddress';
import { httpError } from '../../../models/httpError';

export const state = {
  addressResults: [],
  fullAddress: {},
  searchResultId: '',
  message: new httpError(),
};

export const getters = {
  addressResults: (state) => {
    return state.addressResults;
  },
  fullAddress: (state) => {
    return state.fullAddress;
  },
  searchResultId: (state) => {
    return state.searchResultId;
  },
  message: (state) => state.message,
  getField,
};

export const mutations = {
  SET_ADDRESS_RESULTS(state, results) {
    state.addressResults = results;
  },
  SET_FULL_ADDRESS(state, result) {
    state.fullAddress = result;
  },
  setProgress(state, message) {
    state.message = message;
  },
  SET_SEARCH_RESULT_ID(state, id) {
    state.searchResultId = id;
  },
  updateField,
};

export const actions = {
  async getFullAddress({ dispatch, commit, state }) {
    try {
      let result = await HTTP.get(`SQ/GetFullAddress/${state.searchResultId}`);
      commit('SET_FULL_ADDRESS', result.data);
      return Promise.resolve(result.data);
    } catch (e) {
      let message = '';
      if (!e.response) message = e.message;
      else message = Object.values(e.response.data.errors)[0].toString();
      dispatch(
        'setMessage',
        new httpError({
          message: message,
          httpStatus: 500,
        })
      );
      return Promise.reject(e);
    }
    // try {
    //   let result = await HTTP.get(`SQ/GetFullAddress/${searchResultId}`);
    //   commit('SET_FULL_ADDRESS', result.data);

    //   return Promise.resolve(result.data);
    // } catch (e) {
    //   let message = '';
    //   if (!e.response) message = e.message;
    //   else message = Object.values(e.response.data.errors)[0].toString();
    //   dispatch(
    //     'setMessage',
    //     new httpError({
    //       message: message,
    //       httpStatus: 500,
    //     })
    //   );
    //   return Promise.reject(e);
    // }
  },
  async getOrderAddress({ dispatch }, address) {
    try {
      let result = await HTTP.get(`SQ/GetOrderAddress/${address}`);

      return Promise.resolve(result.data);
    } catch (e) {
      let message = '';
      if (!e.response) message = e.message;
      else message = Object.values(e.response.data.errors)[0].toString();
      dispatch(
        'setMessage',
        new httpError({
          message: message,
          httpStatus: 500,
        })
      );

      return Promise.reject(e);
    }
  },
  async searchAddress({ dispatch, commit }, streetAddress) {
    try {
      if (streetAddress != null && streetAddress.length >= 5) {
        let address = await HTTP.post('SQ/ValidateAddress', {
          country: 'AU',
          formatted_address: streetAddress,
          include_paf: true,
          include_listing: true,
          listing_type: 'both',
        });
        commit('SET_ADDRESS_RESULTS', address.data.data.results);
        return Promise.resolve(address.data.data.results);
      }
    } catch (e) {
      let message = '';
      if (!e.response) message = e.message;
      else message = Object.values(e.response.data.errors)[0].toString();
      dispatch(
        'setMessage',
        new httpError({
          message: message,
          httpStatus: 500,
        })
      );
      return Promise.reject(e);
    }
  },
  completeAddress({ commit, state }, e) {
    var match = state.addressResults.filter((x) => x.formatted_address === e);
    if (match.length > 0) {
      var splitStreetAddress = e.split(' ');
      let addr = new Address();
      addr.suburb = match[0].suburb;
      addr.state = splitStreetAddress[splitStreetAddress.length - 2];
      addr.postCode = match[0].postcode;
      addr.streetAddress = e.substring(0, e.indexOf(','));
      commit('SET_ADDRESS_RESULTS', []);
      return addr;
    }
    return null;
  },
  async createTemplatedEmail({ dispatch }, payload) {
    try {
      let result = await HTTP.post('SQ/SendEmail', payload);
      if (result.data.success) {
        dispatch(
          'setMessage',
          new httpError({
            message: 'Email sent!',
            httpStatus: 200,
          })
        );
      } else {
        dispatch(
          'setMessage',
          new httpError({
            message: 'Failed',
            httpStatus: 500,
          })
        );
      }
      return Promise.resolve(result.data);
    } catch (e) {
      let message = '';
      if (!e.response) message = e.message;
      else message = Object.values(e.response.data.errors)[0].toString();
      dispatch(
        'setMessage',
        new httpError({
          message: message,
          httpStatus: 500,
        })
      );
      return Promise.reject(e);
    }
  },
  async createSupportTicket({ dispatch }, payload) {
    try {
      let result = await HTTP.post(`SQ/CreateSupportTicket`, payload);

      if (result.data.success === true) {
        dispatch(
          'setMessage',
          new httpError({
            message: 'Ticket Submitted',
            httpStatus: 200,
          })
        );
      } else {
        dispatch(
          'setMessage',
          new httpError({
            message: 'Failed',
            httpStatus: 500,
          })
        );
      }
      return Promise.resolve(result.data);
    } catch (e) {
      let message = '';
      if (!e.response) message = e.message;
      else message = Object.values(e.response.data.errors)[0].toString();
      dispatch(
        'setMessage',
        new httpError({
          message: message,
          httpStatus: 500,
        })
      );

      return Promise.reject(e);
    }
  },
  setMessage({ commit }, message) {
    commit('setProgress', message);
    if (message.httpStatus !== 500)
      setTimeout(() => {
        commit('setProgress', new httpError());
      }, 2000);
  },
  setSearchResultId({ commit }, id) {
    commit('SET_SEARCH_RESULT_ID', id);
  },
  setAddressResult({ commit }, data) {
    commit('SET_ADDRESS_RESULTS', data);
  },
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
